// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'
import Fancybox from '/react4xp/components/Fancybox'
import Video from '/react4xp/components/Video'

// svg
import { Play } from '/react4xp/components/Svg/Ux/Ux'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface B2CSectionProps {
    banner?: {
        src: string
		srcSmall: string
		srcMedium: string
        srcLarge: string
		alt?: string
    }
    blocks?: Array<{
        image?: {
            src: string
            alt?: string
        }
        video?: {
            type: 'youtube' | 'vimeo' | 'default'
            url: string
        }
        title?: string
        text?: string
    }>
}

export default function B2CSection({
    banner,
    blocks
}: B2CSectionProps) {
    return (
        <Section
            textColor='text-dark'
            className='b2c-section'
        >
            <div className='grid-container'>

                {banner && (
                    <div className='b2c-section__banner'>
                        <Image
                            srcSmall={[`${banner.srcSmall}`, 575]} // 500x1150
                            srcMedium={[`${banner.srcMedium}`, 767]} // 650x1500
                            srcLarge={[`${banner.srcLarge}`, 991]} // 950x350
                            src={banner.src} // 1350x500
                            alt={banner.alt}
                            className='cover'
                        />
                    </div>
                )}

                {blocks && blocks.length > 0 && (
                    <div className='b2c-section__blocks'>
                        {blocks.map((item, i) => (
                            <div key={i} className='block-item'>

                                <div className={clsx(
                                    'block-item__media'
                                )}>

                                    {item.video && (
                                        <Fancybox
                                            options={{
                                                autoFocus: false,
                                                dragToClose: false
                                            }}
                                        >
                                            <a
                                                href={clsx(
                                                    item.video.type === 'youtube' && 'https://www.youtube.com/watch?v=' + item.video.url,
                                                    item.video.type === 'vimeo' && 'https://www.vimeo.com/' + item.video.url,
                                                    item.video.type === 'default' && item.video.url
                                                )}
                                                data-fancybox
                                                className='block-item__media__video'
                                                aria-label='Click to play the video'
                                            >
                                                <Play />
                                            </a>
                                        </Fancybox>
                                    )}

                                    {item.image && (
                                        <Image
                                            src={item.image?.src} // 450x350
                                            alt={item.image?.alt}
                                            className='cover'
                                        />
                                    )}
                                    
                                </div>

                                {isNonWhitespaceString(item.title) && (
                                    <h3 className='block-item__title'>
                                        {item.title}
                                    </h3>
                                )}

                                {isNonWhitespaceString(item.text) && (
                                    <div className='block-item__text'>
                                        <RichText content={item.text} />
                                    </div>  
                                )}

                            </div>
                        ))}
                    </div>
                )}
                
            </div>
        </Section>
    )
}